import React from 'react'

import '@ant-design/v5-patch-for-react-19'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { version } from '../../../package.json'

import App from './App'
import './index.css'
import './i18n'

/* eslint @typescript-eslint/no-explicit-any: 0 */
;(window as any).global = window

Notification.requestPermission()

const release = `<!-- v${version} -->`

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <div dangerouslySetInnerHTML={{ __html: release }} />
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
